import React from 'react';
import { Grid, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import useConditionalWorkflowStore from '../useConditionalWorkflowStore';
import ItemCondition from './ItemCondition';
import { SelectThenValue } from './components';
import useConditionalWorkflowPathStore from '../../ConditionalWorkflowPath/useConditionalWorkflowPathStore';
import { reportStoreError } from '../../../utils/storeErrorReporter';

class ItemStatementCondition extends React.Component {
  state = {
    updateState: false,
  };

  forceUpdateState = () => {
    let currentState = this.state.updateState;

    this.setState({ updateState: !currentState });
  };

  render() {
    const activeStore = this.props.componentStore || (this.props.conditionalWorkflowPath
      ? useConditionalWorkflowPathStore
      : useConditionalWorkflowStore);
    let { positions, placeholders } = activeStore.getState();
    const {
      indexStatement,
      condition,
      indexLogic,
      outputType,
      availablePlaceholders,
      conditionalWorkflowPath,
    } = this.props;
    const { operators } = condition;

    let elseArray = [];
    let thenArray = [];
    placeholders = placeholders;

    if (
      positions.indexLogic == indexLogic &&
      positions.indexStatement == indexStatement &&
      positions.indexCondition == null &&
      positions.type == 'ELSE'
    ) {
      elseArray = placeholders;
    }
    if (
      positions.indexLogic == indexLogic &&
      positions.indexStatement == indexStatement &&
      positions.indexCondition == null &&
      positions.type == 'THEN'
    ) {
      thenArray = placeholders;
    }

    return (
      <div className={'logic-statement'}>
        {operators && operators.length > 0 ? (
          <Grid container direction={'column'}>
            <Grid
              container
              item
              direction={'column'}
              xs={12}
              className={this.props.classes.conditionFrame}
            >
              <>
                {operators &&
                  operators.map((con, index) => (
                    <ItemCondition
                      classes={this.props.classes}
                      key={index}
                      isExpanded={this.props.isExpanded}
                      indexCondition={index}
                      indexStatement={indexStatement}
                      indexLogic={indexLogic}
                      condition={con}
                      availablePlaceholders={availablePlaceholders}
                      forceUpdateState={this.forceUpdateState}
                      forceUpdateStatement={this.props.forceUpdateState}
                      conditionalWorkflowPath={conditionalWorkflowPath}
                    />
                  ))}
                <Grid item xs={12} className={this.props.classes.spacing}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      try {
                        const store = this.props.componentStore || (conditionalWorkflowPath
                          ? useConditionalWorkflowPathStore
                          : useConditionalWorkflowStore);
                        store.getState().addCondition(indexLogic, indexStatement);
                        this.forceUpdateState();
                        this.props.forceUpdateState();
                      } catch (err) {
                        reportStoreError('conditional_workflow', '', 'addCondition', err);
                      }
                    }}
                    sx={{ textTransform: 'none' }}
                  >
                    Add AND/OR condition
                  </Button>
                </Grid>
              </>
              <>
                <Grid container xs={12} direction={'row'} item alignItems={'baseline'}>
                  <Grid xs={1} container item>
                    Then
                  </Grid>
                  <Grid xs={10} container item>
                    <SelectThenValue
                      value={condition.then.statement.content}
                      onChange={value => {
                        if (value !== condition.then.statement.content) {
                          activeStore.getState().setThenContent(
                            value, indexLogic, indexStatement, true
                          );
                        }
                        this.forceUpdateState();
                      }}
                    />
                  </Grid>
                </Grid>
              </>
            </Grid>
          </Grid>
        ) : (
          <Grid container item xs={12} direction={'column'}>
            <Grid item xs={12} className={this.props.classes.spacing}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  try {
                    const store = this.props.componentStore || (conditionalWorkflowPath
                      ? useConditionalWorkflowPathStore
                      : useConditionalWorkflowStore);
                    store.getState().addStatement(indexLogic);
                    this.props.forceUpdateState();
                  } catch (err) {
                    reportStoreError('conditional_workflow', '', 'addStatement', err);
                  }
                }}
                sx={{ textTransform: 'none' }}
              >
                Add ELSE IF statement
              </Button>
            </Grid>
            <Grid
              container
              direction={'row'}
              alignItems={'center'}
              xs={12}
              className={this.props.isExpanded ? this.props.classes.conditionFrame : ''}
            >
              <Grid
                xs={this.props.isExpanded ? 1 : 12}
                className={this.props.classes.conditionSpacing}
                item
              >
                Else
              </Grid>
              <Grid xs={this.props.isExpanded ? 10 : 12} item>
                <SelectThenValue
                  value={condition.then.statement.content}
                  onChange={value => {
                    if (value !== condition.then.statement.content) {
                      activeStore.getState().setThenContent(
                        value, indexLogic, indexStatement, true
                      );
                    }
                    this.forceUpdateState();
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

export default ItemStatementCondition;
